/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */

const state = {
  meta: {
    title: 'Habit Tracker',
    description: 'A Tracker to Help You Develop Good Habits',
    url: 'https://www.claudiacanu.com/habit-tracker',
    canonical: 'https://www.claudiacanu.com/habit-tracker',
  },
};

const getters = {
  meta: state => state.meta,
};

const mutations = {
  updateMeta: (state, payload) => {
    if (typeof payload.title !== 'undefined') {
      payload.title = `${payload.title} - ClaudiaCanu.com`;
    } else {
      payload.title = 'Habit Tracker';
    }

    if (typeof payload.description === 'undefined') {
      payload.description = 'A Tracker to Help You Develop Good Habits';
    }

    // console.log('updating meta', payload);
    state.meta = {
      title: payload.title,
      description: payload.description,
      url: `https://www.claudiacanu.com${payload.path}`,
    };
  },
};

const actions = {
  updateMeta({ commit }, payload) {
    commit('updateMeta', payload);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
